import { FunctionComponent } from 'react';
import './styles/Select.scss';

import { IOptionsItem } from '../../models';
import { classNames } from '../../utils';

interface ISelectProps {
  label: string;
  options: IOptionsItem[];
  value: string;
  onChange: (newValue: IOptionsItem | null) => void;
  minWidth?: string;
  required?: boolean;
  disabled?: boolean;
}
export const Select: FunctionComponent<ISelectProps> = (props: ISelectProps) => {

  const {
    label,
    options,
    value,
    onChange,
    minWidth,
    required,
    disabled
  } = props;

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const matchingOption = options.find(x => x.value === e.target.value);
    onChange(matchingOption ?? null);
  }

  return (
    <div className='ppa-schedule-select' style={{
      minWidth: minWidth
    }}>
      <label className={classNames({
        disabled
      })}>
        {label}{required ? '*' :''}
      </label>
      <select aria-label={label} onChange={handleChange} value={value} disabled={disabled} required={required}>
        <option value=''>
          Select {label}...
        </option>
        {options.map(x => (
          <option key={x.value} value={x.value}>
            {x.label ?? x.value}
          </option>
        ))}
      </select>
    </div>
  )
}